export default __webpack_public_path__ + "static/media/banner1.60272837.png";